import { createAsyncThunk } from "@reduxjs/toolkit";
import { BandIcalService } from "Bands/services";
import { BAND_ACTIONS, IBandIcalParams } from "Bands/types";
import { IDataKeys } from "shared/types";

export const getBandIcal = createAsyncThunk(
  BAND_ACTIONS.getBandIcal,
  async (
    {
      title,
      band,
      user,
      data,
    }: {
      title: string;
      band: string;
      user?: string;
      data?: IBandIcalParams;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await BandIcalService.getBandIcals({
        title,
        band,
        user,
        data,
      });

      // keep the key even if response is empty
      return {
        [IDataKeys.ical]: response.ical,
        meta: response.meta,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editBandIcal = createAsyncThunk(
  BAND_ACTIONS.editBandIcal,
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: IBandIcalParams;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await BandIcalService.editBandIcal({
        id,
        data,
      });

      // keep the key even if response is empty
      return {
        [IDataKeys.ical]: response.ical,
        meta: response.meta,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
